import { ProductBrand } from '@services/src/models';

export const valueMap = new Map<ProductBrand, string>([
    [ProductBrand.Tena, 'TENA'],
    [ProductBrand.Actimove, 'ACTIMOVE'],

]);

export const map = (value: ProductBrand): string => valueMap.get(value) ?? '';